import ArrowBackIcon from '@mui/icons-material/ArrowBack';

type Props = {
  onClick: () => void;
};

const ArrowBackButton = ({ onClick }: Props) => {
  return (
    <ArrowBackIcon sx={{ fontSize: "36px", cursor: "pointer" }} onClick={onClick} />
  );
};

export default ArrowBackButton;
